import { render, staticRenderFns } from "./set-basic-tem.vue?vue&type=template&id=a1c1f3a2&scoped=true"
import script from "./set-basic-tem.vue?vue&type=script&lang=ts"
export * from "./set-basic-tem.vue?vue&type=script&lang=ts"
import style0 from "./set-basic-tem.vue?vue&type=style&index=0&id=a1c1f3a2&prod&lang=scss&scoped=true"
import style1 from "./set-basic-tem.vue?vue&type=style&index=1&id=a1c1f3a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c1f3a2",
  null
  
)

export default component.exports